module.exports = __webpack_public_path__ + "files/ff98beafe3999bbabfddb6ef3ae07e72.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/foods-2.png
// module id = 1466
// module chunks = 60